<ng-container [formGroup]="form">
  @for (item of options(); track item; let last = $last; let i = $index) {
    <span [attr.automation-id]="automationId() + '-' + item.name | qaSlug">
      <div class="radiobutton-container" [ngClass]="last ? 'mx-1' : 'me-1'">
        <p-radiobutton
          [name]="radioGroupName()"
          [value]="item.value"
          [formControlName]="radioGroupName()"
          [inputId]="automationId() + '-' + item.name | qaSlug"
        />
        <label class="control-label" [for]="automationId() + '-' + item.name | qaSlug" [innerHTML]="item.name"></label>
      </div>
    </span>
  }
</ng-container>
